module.exports = __webpack_public_path__ + "static/img-2-efa3fa42fd19f946653974eb39235824.jpg";